import React from 'react';
import TextStyle from '@rezdy/components/TextStyle';
import Button from '@rezdy/components/Button';
import { Title } from './Styled';
import { push } from '../../services/routing';
import { SIGN_IN } from '../../constants/routes';
import { WithTranslation, withTranslation } from 'react-i18next';
export class VerifyEmailSuccess extends React.PureComponent<WithTranslation> {
    // 5 seconds
    timeout = 1000 * 5;

    componentDidMount() {
        setTimeout(() => {
            push(SIGN_IN);
        }, this.timeout);
    }

    handleOnClick = () => {
        push(SIGN_IN);
    };

    render(): React.ReactNode {
        const { i18n } = this.props;
        return (
            <React.Fragment>
                <Title>{i18n.t('Your email is now verified')}</Title>
                <TextStyle as="p">
                    {i18n.t(
                        'You will be redirected to login screen in a few seconds. Alternatively, click on the button bellow.'
                    )}
                </TextStyle>
                <Button action="primary" onClick={this.handleOnClick} type="button">
                    {i18n.t('Login to setup your business')}
                </Button>
            </React.Fragment>
        );
    }
}

export default withTranslation()(VerifyEmailSuccess);
